import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
} from '../../../../../../../utils/labels/globalAccessibility.labels';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
} from '../../../../../../../utils/labels/globalCommonBrowseLabels.labels';
import { GlobalGenericLabels } from '../../../../../../../utils/labels/globalGeneric.labels';
import { GlobalAddToBagLabels } from '../../../../../../../utils/labels/globalAddedToBag.labels';
import globalCartItemTileLabels from '../../../../../../../utils/labels/globalCartItemTile.labels';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import {
  QUICK_VIEW_LABELS,
  quickViewLabels,
} from '../../../../QuickViewModal/Labels/QuickView.labels';

export const PRODUCT_PICKUP_LABELS = 'Browse.ProductPickup';
export const shippingLabelFromGenericLabels = 'global.generic.lbl_shipping';

// Pickup Labels
export const lblProductPickupALLAVAILABLE = 'lbl_Product_pickup_ALL_AVAILABLE';
export const lblProductPickupBOPISAVAILABLE = 'lbl_Product_pickup_BOPIS_AVAILABLE';
export const lblProductPickupBOPISDISABLEDFITSHUSKY =
  'lbl_Product_pickup_BOPIS_DISABLED_FITS_HUSKY';
export const lblProductPickupBOPISDISABLEDFITSPLUS = 'lbl_Product_pickup_BOPIS_DISABLED_FITS_PLUS';
export const lblProductPickupBOPISDISABLEDFITSSLIM = 'lbl_Product_pickup_BOPIS_DISABLED_FITS_SLIM';
export const lblProductPickupBOPISINTHESTORERedesign =
  'lbl_Product_pickup_BOPIS_IN_THE_STORE_redesign';
export const lblProductPickupBOPISNOTAVAILABLE = 'lbl_Product_pickup_BOPIS_NOT_AVAILABLE';
export const lblProductPickupBOPISONLYAVAILABLE = 'lbl_Product_pickup_BOPIS_ONLY_AVAILABLE';
export const lblProductPickupBOSSAVAILABLE = 'lbl_Product_pickup_BOSS_AVAILABLE';
export const lblProductPickupBOSSNOTAVAILABLE = 'lbl_Product_pickup_BOSS_NOT_AVAILABLE';
export const lblProductPickupBOSSONLYAVAILABLE = 'lbl_Product_pickup_BOSS_ONLY_AVAILABLE';
export const lblProductPickupCHANGESTORE = 'lbl_Product_pickup_CHANGE_STORE';
export const lblProductPickupCHANGESTOREDM = 'lbl_Product_pickup_CHANGE_STORE_DM';
export const lblProductPickupCHANGESTORERedesign = 'lbl_Product_pickup_CHANGE_STORE_redesign';
export const lblProductPickupCLOSED = 'lbl_Product_pickup_CLOSED';
export const lblProductPickupCLOSESIN = 'lbl_Product_pickup_CLOSES_IN';
export const lblProductPickupEXTRANORUSHPICKUPOFFER =
  'lbl_Product_pickup_EXTRA_NO_RUSH_PICKUP_OFFER';
export const lblProductPickupFINDSTORE = 'lbl_Product_pickup_FIND_STORE';
export const lblProductPickupFINDSTORERedesign = 'lbl_Product_pickup_FIND_STORE_redesign';
export const lblProductPickupFREESHIPPING = 'lbl_Product_pickup_FREE_SHIPPING';
export const lblProductPickupFREESHIPPINGRedesign = 'lbl_Product_pickup_FREE_SHIPPING_redesign';
export const lblProductPickupGETITASAP = 'lbl_Product_pickup_GET_IT_ASAP';
export const lblProductPickupHIDEITEM = 'lbl_Product_pickup_HIDE_ITEM';
export const lblProductPickupNOMINPURCHASE = 'lbl_Product_pickup_NO_MIN_PURCHASE';
export const lblProductPickupNOMINPURCHASERedesign = 'lbl_Product_pickup_NO_MIN_PURCHASE_redesign';
export const lblProductPickupNORUSHPICKUP = 'lbl_Product_pickup_NO_RUSH_PICKUP';
export const lblProductPickupOPENSTOMORROWAT = 'lbl_Product_pickup_OPENS_TOMORROW_AT';
export const lblProductPickupOPENUNTIL = 'lbl_Product_pickup_OPEN_UNTIL';
export const lblProductPickupOUTOFSTOCKTEXTRedesign =
  'lbl_Product_pickup_OUT_OF_STOCK_TEXT_redesign';
export const lblProductPickupOUTOFSTOCKButtonRedesign =
  'lbl_Product_pickup_OUT_OF_STOCK_button_redesign';
export const lblProductPickupPARTIALAVAILABLE = 'lbl_Product_pickup_PARTIAL_AVAILABLE';
export const lblProductPickupPICKUPINSTEAD = 'lbl_Product_pickup_PICKUP_INSTEAD';
export const lblProductPickupPICKUPINSTORE = 'lbl_Product_pickup_PICKUP_IN_STORE';
export const lblProductPickupPICKUPINSTOREDM = 'lbl_Product_pickup_PICKUP_IN_STORE_DM';
export const lblProductPickupPICKUPINSTORERedesign = 'lbl_Product_pickup_PICKUP_IN_STORE_redesign';
export const lblProductPickupPICKITUPFIRSTTEXT = 'lbl_Product_pickup_PICK_IT_UP_FIRST_TEXT';
export const lblProductPickupPICKITUPICONNAME = 'lbl_Product_pickup_PICK_IT_UP_ICON_NAME';
export const lblProductPickupPICKITUPSECONDTEXT = 'lbl_Product_pickup_PICK_IT_UP_SECOND_TEXT';
export const lblProductPickupPRODUCTBOPIS = 'lbl_Product_pickup_PRODUCT_BOPIS';
export const lblProductPickupSEARCHOTHERSTORES = 'lbl_Product_pickup_SEARCH_OTHER_STORES';
export const lblProductPickupSELECTEDSTORE = 'lbl_Product_pickup_SELECTED_STORE';
export const lblProductPickupSELECTSIZEPICKUPWARNINGTEXTRedesign =
  'lbl_Product_pickup_SELECT_SIZE_PICKUP_WARNING_TEXT_redesign';
export const lblProductPickupSELECTSIZEWARNINGTEXTRedesign =
  'lbl_Product_pickup_SELECT_SIZE_WARNING_TEXT_redesign';
export const lblProductPickupSHIPPINGMETHODTITLE = 'lbl_Product_pickup_SHIPPING_METHOD_TITLE';
export const lblProductPickupSHIPITICONNAME = 'lbl_Product_pickup_SHIP_IT_ICON_NAME';
export const lblProductPickupSHIPTOHOMEICONNAME = 'lbl_Product_pickup_SHIP_TO_HOME_ICON_NAME';
export const lblProductPickupSHOWITEM = 'lbl_Product_pickup_SHOW_ITEM';
export const lblProductPickupSPACEONE = 'lbl_Product_pickup_SPACE_ONE';
export const lblProductPickupTITLEDEFAULTNOSTORE = 'lbl_Product_pickup_TITLE_DEFAULT_NOSTORE';
export const lblAlsoAvailableIn = 'lbl_also_available_in';
export const lblCheckOtherLocations = 'lbl_check_other_locations';
export const lblFreePickupLocation = 'lbl_free_pickup_location';
export const lblStoreUnavailableError = 'lbl_store_unavailable_error';
export const lblStoreUnavailableErrorBoss = 'lbl_store_unavailable_error_boss';
export const lblStoresNearby = 'lbl_stores_nearby';

export const labelsObject = {
  Browse: {
    ProductPickup: {
      [lblProductPickupALLAVAILABLE]: 'All items available in this store',
      [lblProductPickupBOPISAVAILABLE]: 'Pick up TODAY!',
      [lblProductPickupBOPISDISABLEDFITSHUSKY]: 'husky',
      [lblProductPickupBOPISDISABLEDFITSPLUS]: 'plus',
      [lblProductPickupBOPISDISABLEDFITSSLIM]: 'slim',
      [lblProductPickupBOPISINTHESTORERedesign]: 'at this store',
      [lblProductPickupBOPISNOTAVAILABLE]:
        'Sorry none of your selected items are available at this store',
      [lblProductPickupBOPISONLYAVAILABLE]: 'Item available for pickup TODAY',
      [lblProductPickupBOSSAVAILABLE]: 'Or choose NO RUSH Pickup ',
      [lblProductPickupBOSSNOTAVAILABLE]: 'This store is currently unavailable for Ship to Store',
      [lblProductPickupBOSSONLYAVAILABLE]: 'Choose NO RUSH Pickup ',
      [lblProductPickupCHANGESTORE]: '(Change Store)',
      [lblProductPickupCHANGESTOREDM]: 'Change Store',
      [lblProductPickupCHANGESTORERedesign]: 'Change',
      [lblProductPickupCLOSED]: 'Closed',
      [lblProductPickupCLOSESIN]: 'Closes in',
      [lblProductPickupEXTRANORUSHPICKUPOFFER]: 'Extra 5% Off',
      [lblProductPickupFINDSTORE]: 'Find in Store',
      [lblProductPickupFINDSTORERedesign]: 'Find In Store',
      [lblProductPickupFREESHIPPING]: 'FREE Shipping Every Day!',
      [lblProductPickupFREESHIPPINGRedesign]: 'Free Shipping',
      [lblProductPickupGETITASAP]: 'Get it ASAP!',
      [lblProductPickupHIDEITEM]: 'Hide Item',
      [lblProductPickupNOMINPURCHASE]: 'No Minimum Purchase Required.',
      [lblProductPickupNOMINPURCHASERedesign]: 'No minimum required',
      [lblProductPickupNORUSHPICKUP]: 'Ship to Store',
      [lblProductPickupOPENSTOMORROWAT]: 'Opens tomorrow at ',
      [lblProductPickupOPENUNTIL]: 'Open until',
      [lblProductPickupOUTOFSTOCKTEXTRedesign]: 'Out of Stock',
      [lblProductPickupOUTOFSTOCKButtonRedesign]: 'Check Other Stores',
      [lblProductPickupPARTIALAVAILABLE]:
        '#availableItemsCount of #totalItemsCount Items in this store',
      [lblProductPickupPICKUPINSTEAD]: 'Pickup Instead',
      [lblProductPickupPICKUPINSTORE]: 'PICK UP IN STORE',
      [lblProductPickupPICKUPINSTOREDM]: 'Pickup In Store',
      [lblProductPickupPICKUPINSTORERedesign]: 'Pick-up In Store',
      [lblProductPickupPICKITUPFIRSTTEXT]: 'Need it ASAP?',
      [lblProductPickupPICKITUPICONNAME]: 'Pick it up!',
      [lblProductPickupPICKITUPSECONDTEXT]: 'Get it today!',
      [lblProductPickupPRODUCTBOPIS]: 'Buy online - Pick up in store',
      [lblProductPickupSEARCHOTHERSTORES]: 'Search Other Stores',
      [lblProductPickupSELECTEDSTORE]: 'Selected Store',
      [lblProductPickupSELECTSIZEPICKUPWARNINGTEXTRedesign]: 'Select a size to preview pickup date',
      [lblProductPickupSELECTSIZEWARNINGTEXTRedesign]: 'Select a size to preview availability',
      [lblProductPickupSHIPPINGMETHODTITLE]: 'Delivery Method',
      [lblProductPickupSHIPITICONNAME]: 'Ship it!',
      [lblProductPickupSHIPTOHOMEICONNAME]: 'Ship to Home',
      [lblProductPickupSHOWITEM]: 'Show Item',
      [lblProductPickupSPACEONE]: ' ',
      [lblProductPickupTITLEDEFAULTNOSTORE]: 'Select Store',
      [lblAlsoAvailableIn]: 'Also available in',
      [lblCheckOtherLocations]: 'check other locations',
      [lblFreePickupLocation]: 'Free Pickup at this location',
      [lblStoreUnavailableError]:
        'This size/color is not available for Pickup at stores nearby. Modify your selection or',
      [lblStoreUnavailableErrorBoss]: 'Ship to Store is unavailable at your favorite store.',
      [lblStoresNearby]: 'stores nearby',
      lbl_available_today: 'Available today',
      lbl_available_in_store_only: 'Available in-store only',
      lbl_Product_pickup_Get_it: 'Get it',
      lbl_Product_pickup_Free_Pick_Up: 'Free Pick Up',
    },
  },
};

export function getProductPickupLabels() {
  return getLabelFromCopyOrFromTranslation(PRODUCT_PICKUP_LABELS, labelsObject);
}

export function getQuickViewLabels() {
  return {
    ...getLabelFromCopyOrFromTranslation(QUICK_VIEW_LABELS, quickViewLabels),
    ...getLabelFromCopyOrFromTranslation(GLOBAL_COMMON_BROWSE_LABELS, globalCommonBrowseLabels),
    ...getLabelFromCopyOrFromTranslation(GLOBAL_ACCESSIBILITY_LABELS, GlobalAccessibilityLabels),
    lbl_shipping: getLabelFromCopyOrFromTranslation(
      shippingLabelFromGenericLabels,
      GlobalGenericLabels
    ),
    lbl_Product_pickup_SELECTED_STORE: getLabelFromCopyOrFromTranslation(
      `${PRODUCT_PICKUP_LABELS}.lbl_Product_pickup_SELECTED_STORE`,
      labelsObject
    ),
    lbl_pickup_instead_free_order: getLabelFromCopyOrFromTranslation(
      `global.addedToBagModal.lbl_pickup_instead_free_order`,
      GlobalAddToBagLabels
    ),
    lbl_cartTile_pickUpToday: getLabelFromCopyOrFromTranslation(
      `global.cartItemTile.lbl_cartTile_pickUpToday`,
      globalCartItemTileLabels
    ),
  };
}

export function getAccessibilityLabels() {
  return getLabelFromCopyOrFromTranslation(GLOBAL_ACCESSIBILITY_LABELS, GlobalAccessibilityLabels);
}
